import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setHeaderColor, setHeaderTextColor, setloading } from '../../Redux/ActionCreater';

const AdventskalenderStretchband = () => {
    let dispatch = useDispatch();
    useEffect(() => {
        dispatch(setloading(false));
        dispatch(setHeaderColor('#facee1'));
            dispatch(setHeaderTextColor('#fff'));
    }, []);
    return (
        <div className="coming-soon-page d-flex justify-content-center align-items-center">
            <h1 className="coming-soon-text">COMING SOON</h1>
        </div>
    )
}

export default AdventskalenderStretchband